/* src/app/features/taxas-juros/taxa-juros-media-agente/taxa-juros-media-agente-listagem.component.scss */
.obs-erro {
  font-style: italic;
}
.taxa-maior-que-maxima {
  background-color: #FFDCDB;
}
.letra-miuda {
  font-size: 14px;
  font-style: italic;
  text-align: bottom;
}
/*# sourceMappingURL=taxa-juros-media-agente-listagem.component.css.map */
